import { render, staticRenderFns } from "./index.vue?vue&type=template&id=42adb25f"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42adb25f')) {
      api.createRecord('42adb25f', component.options)
    } else {
      api.reload('42adb25f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=42adb25f", function () {
      api.rerender('42adb25f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/editor/index.vue"
export default component.exports